<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogGuaranteeIllness guaranteeModal"
    @onClose="$emit('onClose')"
  >
    <template v-slot:title>
      <h1 class="dialogGuaranteeIllness-title">病気・ケガの保障</h1>
    </template>
    <v-card class="dialogGuaranteeIllness-content">
      <v-card-text class="dialogGuaranteeIllness-content">
        <div class="his-tbl_wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="5">保障内容</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th></th>
                <th>Ａ型</th>
                <th>Ｂ型</th>
                <th>Ｃ型</th>
                <th>Ｄ型</th>
              </tr>
              <tr>
                <td>１口<br />あたりの<br />保障額</td>
                <td data-label="Ａ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>入院</th>
                        <td>１，０００円/日</td>
                      </tr>
                      <tr>
                        <th rowspan="3">手術</th>
                        <td>(外来)<br />入院保険金日額の１０倍</td>
                      </tr>
                      <tr>
                        <td>(入院)<br />入院保険金日額の２０倍</td>
                      </tr>
                      <tr>
                        <td>(重大)<br />入院保険金日額の４０倍</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td data-label="Ｂ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>通院</th>
                        <td>６００円/日</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td data-label="Ｃ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>入院</th>
                        <td>１，０００円/日</td>
                      </tr>
                      <tr>
                        <th rowspan="3">手術</th>
                        <td>(外来)<br />入院保険金日額の１０倍</td>
                      </tr>
                      <tr>
                        <td>(入院)<br />入院保険金日額の２０倍</td>
                      </tr>
                      <tr>
                        <td>(重大)<br />入院保険金日額の４０倍</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td data-label="Ｄ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>通院</th>
                        <td>６００円/日</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>ご加入条件</td>
                <td data-label="Ａ型">単独加入が可能</td>
                <td data-label="Ｂ型">Ａ型とセットでの<br />加入が必要</td>
                <td data-label="Ｃ型">Ａ型とセットでの<br />加入が必要</td>
                <td data-label="Ｄ型">
                  Ａ型・Ｂ型・Ｃ型と<br />セットで加入が必要
                </td>
              </tr>
              <tr>
                <td>口数の制限</td>
                <td data-label="Ａ型">３～２０口の範囲内</td>
                <td data-label="Ｂ型">３口以上、<br />Ａ型の口数以下</td>
                <td data-label="Ｃ型">３口以上、<br />Ａ型の口数以下</td>
                <td data-label="Ｄ型">
                  ３口以上、Ｂ型および<br />Ｃ型の口数以下
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pointTitle">特長</div>
          <div class="pointBox">
            <dl>
              <dt>1</dt>
              <dd>
                病気だけでなく<br /><strong>不慮の事故によるケガも保障</strong>
              </dd>
            </dl>
            <dl>
              <dt>2</dt>
              <dd>
                加入には健康状態に関する告知だけで<br /><strong
                  >医師の診査は不要</strong
                >
              </dd>
            </dl>
            <dl>
              <dt>3</dt>
              <dd>
                一回の入院で180日まで、継続の保険期間を通じて<br /><strong
                  >通算1,000日まで保障</strong
                >
              </dd>
            </dl>

            <dl>
              <dt>4</dt>
              <dd>保障の対象となる手術は<br /><strong>約1,000種類</strong></dd>
            </dl>
            <dl>
              <dt>5</dt>
              <dd>地震や津波など<br /><strong>天災によるケガも保障</strong></dd>
            </dl>
            <dl>
              <dt>6</dt>
              <dd><strong>満79歳まで</strong><br />継続加入が可能</dd>
            </dl>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </app-dialog>
</template>

<script>
export default {
  name: 'DialogGuaranteeIllness',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialogGuaranteeIllness {
  width: 690px;
  max-width: 700px;
  &-content {
    &.v-card__text {
      padding: 0 25px 20px;
    }
  }
  &-title {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #333;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }
  .his-tbl_wrapper {
    & > .pointBox {
      & dl {
        min-height: 60px;
      }
    }
  }
}
</style>
